// extracted by mini-css-extract-plugin
export default {"container":"FilmView_container__-PJDm"};